
import axios from '../../axiosCF';
import { ISuekEducationAction } from '../../interfaces/action/ISuekEducationAction';
import { ESUEKEducationDropzoneType, ISuekEducation } from '../../interfaces/domain/ISuekEducation';
import { IFormData } from './../../shared/utility';
import { ActionTypes } from './actionTypes';

export const findSuekEducationsSuccess = (
  suekEducations: ISuekEducation[]
): ISuekEducationAction => {
  return {
    type: ActionTypes.FIND_SUEK_EDUCATION_SUCCESS,
    suekEducations
  };
};

export const findSuekEducationsFail = (error: string): ISuekEducationAction => {
  return {
    type: ActionTypes.FIND_SUEK_EDUCATION_FAIL,
    error
  };
};

export const findSuekEducationsStart = (): ISuekEducationAction => {
  return {
    type: ActionTypes.FIND_SUEK_EDUCATION_START
  };
};

export const findSuekEducations = (): Function => {
  return async (dispatch: any): Promise<void> => {
    dispatch(findSuekEducationsStart());
    try {
      const response = await axios.get("/api/suekEducations/find");
      dispatch(findSuekEducationsSuccess(response.data));
    } catch (error) {
      dispatch(findSuekEducationsFail(error as string));
    }
  };
};

export const getSuekEducationSuccess = (
  suekEducation: ISuekEducation
): ISuekEducationAction => {
  return {
    type: ActionTypes.GET_SUEK_EDUCATION_SUCCESS,
    suekEducation
  };
};

export const getSuekEducationFail = (error: string): ISuekEducationAction => {
  return {
    type: ActionTypes.GET_SUEK_EDUCATION_FAIL,
    error
  };
};

export const getSuekEducationStart = (): ISuekEducationAction => {
  return {
    type: ActionTypes.GET_SUEK_EDUCATION_START
  };
};

export const getSuekEducation = (id: number): Function => {
  return async (dispatch: any): Promise<void> => {
    dispatch(getSuekEducationStart());
    try {
      const response = await axios.get(`/api/suekEducations/get?id=${id}`);
      dispatch(getSuekEducationSuccess(response.data));
    } catch (error) {
      dispatch(getSuekEducationFail(error as string));
    }
  };
};


export const getSuekEducationClear= (): ISuekEducationAction => {
  return {
    type: ActionTypes.GET_SUEK_EDUCATION_CLEAR
  };
};

export const updateSuekEducationSuccess = (suekEducation: ISuekEducation): ISuekEducationAction => {
  return {
      type: ActionTypes.UPDATE_SUEK_EDUCATION_SUCCESS,
      suekEducation
  }
};

export const updateSuekEducationFail = (error: string): ISuekEducationAction => {
  return {
      type: ActionTypes.UPDATE_SUEK_EDUCATION_FAIL,
      error
  }
};

export const updateSuekEducationStart = (): ISuekEducationAction => {
  return {
      type: ActionTypes.UPDATE_SUEK_EDUCATION_START
  }
}

export const updateSuekEducation = (formData: IFormData) => {
  return async (dispatch: any): Promise<ISuekEducation | null> => {
      dispatch(updateSuekEducationStart());
      try {
          const response = await axios.put(`/api/suekEducations/update`, formData);
          const suekEducation = response.data as ISuekEducation;
          dispatch(updateSuekEducationSuccess(suekEducation));
          return suekEducation;
      } catch (error) {
          dispatch(updateSuekEducationFail(error as string));
          return null;
      }        
  };
};


export const uploadSuekEducationFilesSuccess = (suekEducation: ISuekEducation): ISuekEducationAction => {
  return {
      type: ActionTypes.UPLOAD_SUEK_EDUCATION_FILES_SUCCESS,
      suekEducation
  }
};

export const uploadSuekEducationFilesFail = (error: string): ISuekEducationAction => {
  return {
      type: ActionTypes.UPLOAD_SUEK_EDUCATION_FILES_FAIL,
      error
  }
};

export const uploadSuekEducationFilesStart = (): ISuekEducationAction => {
  return {
      type: ActionTypes.UPLOAD_SUEK_EDUCATION_FILES_START
  }
}

export const uploadSuekEducationFiles = (formData: FormData) => {
  return async (dispatch: any): Promise<ISuekEducation | null> => {
      dispatch(uploadSuekEducationFilesStart());
      try {
          const response = await axios.post(`/api/suekEducations/uploadFiles`, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          });
          const suekEducation = response.data as ISuekEducation;
          dispatch(uploadSuekEducationFilesSuccess(suekEducation));
          return suekEducation;
      } catch (error) {
          dispatch(uploadSuekEducationFilesFail(error as string));
          return null;
      }        
  };
};

export const deleteSuekEducationFileSuccess = (suekEducation: ISuekEducation): ISuekEducationAction => {
  return {
      type: ActionTypes.DELETE_SUEK_EDUCATION_FILE_SUCCESS,
      suekEducation
  }
};

export const deleteSuekEducationFileFail = (error: string): ISuekEducationAction => {
  return {
      type: ActionTypes.DELETE_SUEK_EDUCATION_FILE_FAIL,
      error
  }
};

export const deleteSuekEducationFileStart = (): ISuekEducationAction => {
  return {
      type: ActionTypes.DELETE_SUEK_EDUCATION_FILE_START
  }
};

export const deleteSuekEducationFile = (
  id: number,
  name: string,
  type: ESUEKEducationDropzoneType
) => {
  return async (dispatch: any): Promise<ISuekEducation | null> => {
      dispatch(deleteSuekEducationFileStart());
      try {
          const response = await axios.delete(`/api/suekEducations/deleteFile`, {
            params: {
              id,
              name,
              type
            }
          });
          const suekEducation = response.data as ISuekEducation;
          dispatch(deleteSuekEducationFileSuccess(suekEducation));
          return suekEducation;
      } catch (error) {
          dispatch(deleteSuekEducationFileFail(error as string));
          return null;
      }
  };
};
